enum UserAppType
{
    standard = 0, bezlogowania = 1, wymiar6x3 = 2
}

export default UserAppType;